import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useDealershipStore = defineStore('dealership', () => {
    const all = ref(null);

    const actions = {
        search: (params) => axios.get('/api/v1/dealerships', { params }),
        storeDealership: (params) => axios.post('/api/v1/dealerships', params),
        updateDealership: (params) => axios.patch('/api/v1/dealerships/' + params.hash, params),
    };

    return {
        all,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useDealershipStore.acceptHMRUpdate);
}
